"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rngFromSeed = rngFromSeed;
exports.generateNickname = generateNickname;
exports.randomAvatarConfig = randomAvatarConfig;
exports.coversHair = coversHair;
exports.defaultIdentity = defaultIdentity;
const options_1 = require("./options");
const ADJECTIVES = [
    'Cozy', 'Velvet', 'Rustic', 'Modern', 'Boho', 'Nordic', 'Sunny', 'Marble', 'Linen', 'Vintage',
    'Gilded', 'Airy', 'Bold', 'Mellow', 'Coastal', 'Urban', 'Earthy', 'Plush', 'Minimal', 'Retro',
    'Dapper', 'Breezy', 'Woven', 'Lofty', 'Serene', 'Chic', 'Warm', 'Eclectic', 'Pastel', 'Walnut',
];
const NOUNS = [
    'Ottoman', 'Sofa', 'Lamp', 'Armchair', 'Rug', 'Nook', 'Loft', 'Studio', 'Atelier', 'Mantel',
    'Alcove', 'Cushion', 'Credenza', 'Sconce', 'Terrace', 'Parlor', 'Drape', 'Trellis', 'Bureau', 'Chaise',
    'Pendant', 'Hearth', 'Canopy', 'Easel', 'Swatch', 'Palette', 'Gallery', 'Veranda', 'Settee', 'Fern',
];
const NICKNAME_NUMBER_RANGE = 1000;
function hashString(seed) {
    let h = 0x811c9dc5;
    for (let i = 0; i < seed.length; i++) {
        h ^= seed.charCodeAt(i);
        h = Math.imul(h, 0x01000193);
    }
    return h >>> 0;
}
/** Deterministic generator (mulberry32): the same seed always yields the same sequence. */
function rngFromSeed(seed) {
    let state = hashString(seed);
    return () => {
        state = (state + 0x6d2b79f5) | 0;
        let t = Math.imul(state ^ (state >>> 15), 1 | state);
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}
function pick(rng, list) {
    return list[Math.floor(rng() * list.length)];
}
function generateNickname(rng = Math.random) {
    return `${pick(rng, ADJECTIVES)}${pick(rng, NOUNS)}${Math.floor(rng() * NICKNAME_NUMBER_RANGE)}`;
}
function randomAvatarConfig(rng = Math.random) {
    const clothing = pick(rng, options_1.AVATAR_OPTIONS.clothing);
    const freeProps = options_1.AVATAR_OPTIONS.prop.filter(prop => prop !== 'none' && !options_1.MEDAL_PROPS[prop]);
    const tops = options_1.AVATAR_OPTIONS.top.filter(top => top !== 'none' && !options_1.RANDOM_EXCLUDED_TOPS.includes(top));
    return {
        v: 1,
        skin: pick(rng, options_1.AVATAR_OPTIONS.skin),
        top: pick(rng, tops),
        headwear: rng() < 0.08 ? 'hat' : 'none',
        hairColor: pick(rng, options_1.AVATAR_OPTIONS.hairColor),
        hatColor: pick(rng, options_1.AVATAR_OPTIONS.hatColor),
        eyes: pick(rng, options_1.AVATAR_OPTIONS.eyes),
        eyebrows: pick(rng, options_1.AVATAR_OPTIONS.eyebrows),
        mouth: pick(rng, options_1.AVATAR_OPTIONS.mouth),
        facialHair: 'none',
        glasses: rng() < 0.4 ? pick(rng, options_1.AVATAR_OPTIONS.glasses.filter(id => id !== 'none')) : 'none',
        glassesColor: pick(rng, options_1.AVATAR_OPTIONS.glassesColor),
        clothing,
        clothesColor: clothing === 'suit' ? pick(rng, options_1.SUIT_COLORS) : pick(rng, options_1.AVATAR_OPTIONS.clothesColor),
        accentColor: pick(rng, options_1.AVATAR_OPTIONS.accentColor),
        prop: rng() < 0.8 ? pick(rng, freeProps) : 'none',
        propColor: pick(rng, options_1.AVATAR_OPTIONS.propColor),
        background: pick(rng, options_1.AVATAR_OPTIONS.background),
        backgroundRotation: Math.floor(rng() * 360),
    };
}
/** Whether this headwear hides the hairstyle entirely. */
function coversHair(headwear) {
    return options_1.HAIR_COVERING_HEADWEAR.includes(headwear);
}
/**
 * The identity a user has before one is stored. Seeded by the uid, so every
 * caller derives the same nickname and avatar without a database row.
 * `attempt` yields the next candidate when the nickname is already taken.
 */
function defaultIdentity(uid, attempt = 0) {
    return {
        nickname: generateNickname(rngFromSeed(`nickname:${uid}:${attempt}`)),
        avatar: randomAvatarConfig(rngFromSeed(`avatar:${uid}`)),
    };
}
